const features = [
  {
    icon: "ri-mental-health-line",
    title: "Mindset Coaching",
    description: "Rewire limiting beliefs and build an abundance mindset with neuroscience-backed techniques from world-class coaches.",
    color: "text-teal-600",
    bg: "bg-teal-50",
  },
  {
    icon: "ri-heart-pulse-line",
    title: "Life Coaching",
    description: "Design a life of purpose, balance, and fulfillment. Create your personal blueprint and live intentionally.",
    color: "text-rose-600",
    bg: "bg-rose-50",
  },
  {
    icon: "ri-briefcase-4-line",
    title: "Career Coaching",
    description: "Land your dream role, negotiate your worth, and build a career that aligns with your deepest values.",
    color: "text-amber-600",
    bg: "bg-amber-50",
  },
  {
    icon: "ri-building-4-line",
    title: "Corporate Success",
    description: "Elevate your leadership, inspire high-performing teams, and drive organizational excellence.",
    color: "text-slate-600",
    bg: "bg-slate-100",
  },
  {
    icon: "ri-leaf-line",
    title: "Wellness & Resilience",
    description: "Build mental resilience, manage stress, and create sustainable wellness practices for lasting vitality.",
    color: "text-green-600",
    bg: "bg-green-50",
  },
  {
    icon: "ri-community-line",
    title: "Community & Collaboration",
    description: "Connect with like-minded growth seekers, share your journey, and collaborate on transformative projects.",
    color: "text-indigo-600",
    bg: "bg-indigo-50",
  },
];

export default function FeaturesSection() {
  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        {/* Header */}
        <div className="text-center mb-16">
          <span className="text-teal-600 text-sm font-semibold tracking-widest uppercase">What We Offer</span>
          <h2
            className="text-4xl md:text-5xl font-bold text-gray-900 mt-3 mb-4"
            style={{ fontFamily: "'Playfair Display', serif" }}
          >
            Every Dimension of Growth,
            <br />
            <span className="text-teal-600">Covered</span>
          </h2>
          <p className="text-gray-500 text-lg max-w-2xl mx-auto">
            From inner transformation to outer success — Mind Odyssey has the coaching programs and community to support every step of your journey.
          </p>
        </div>

        {/* Feature Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {features.map((f) => (
            <div
              key={f.title}
              className="group p-8 rounded-2xl border border-gray-100 hover:border-teal-200 bg-white hover:bg-teal-50/30 transition-all cursor-pointer"
            >
              <div className={`w-14 h-14 flex items-center justify-center rounded-xl ${f.bg} mb-5`}>
                <i className={`${f.icon} text-2xl ${f.color}`} />
              </div>
              <h3 className="text-lg font-semibold text-gray-900 mb-3">{f.title}</h3>
              <p className="text-gray-500 text-sm leading-relaxed">{f.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
